import { FlowsheetContext } from "@/components/FlowSheetEditor/FlowsheetProvider"
import { toBase64 } from "@/components/FlowSheetEditor/utils"
import { PlusOutlined } from "@ant-design/icons"
import { Node } from "@antv/x6"
import { Upload } from "antd"
import Title from "antd/lib/typography/Title"
import classNames from "classnames"
import { useContext, useEffect, useState } from "react"
import { UnitLayout } from "./UnitLayout"
import { useReloadWhenUnitChange } from "./useReloadWhenUnitChange"
import { RollBackButton } from "./RollBackButton"

interface ImageNodePanelProps {
  unit: Node
}
export const ImageNodePanel = (props: ImageNodePanelProps) => {
  const {unit} = props
  const data = unit.getData()
  const [override, setOverride] = useState(data.override || false)
  const unitSize = unit.getSize();
  const unitPosition = unit.getPosition();
  const [url, setUrl] = useState(data.url)
  const {changeCellProps, isTemplate} = useContext(FlowsheetContext)
  const [size, setSize] = useState(unitSize)
  const [position, setPosition] = useState(unitPosition)
  useReloadWhenUnitChange(unit)

  useEffect(() => {
    setSize(unitSize)
  }, [unitSize.width, unitSize.height])

  useEffect(() => {
    setPosition(unitPosition)
  }, [position.x, position.y])

  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type="button">
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  const onImageUpload = async (e) => {
    const imageDataUrl = await toBase64(e.file)
    setUrl(imageDataUrl)
    const changes = {url: imageDataUrl} as any
    if (!isTemplate) {
      changes.override = true
    }
    changeCellProps(unit.id, changes)
    return false
  }

  const onLayoutChange = () => {
    if (!isTemplate) {
      changeCellProps(unit.id, {override: true})
      setOverride(true)
    }
  }

  const handleOverrideChange = (isOverride) => {
    setOverride(isOverride)
  }

  return <div className="unit-container">
    <div className={classNames('unit-header', 'flex-space-btw')}>
      <div>Image Options</div>
      <RollBackButton override={override} node={unit} onOverrideChange={handleOverrideChange} />
    </div>
    <div className="p-1">
      <UnitLayout unit={unit} onChange={onLayoutChange} />
      <Title level={5} className="mt-1">Image</Title>
      <Upload
        name="avatar"
        listType="picture-card"
        className="avatar-uploader"
        customRequest={onImageUpload}
        showUploadList={false}
      >
        {url ? <img src={url} alt="avatar" style={{ maxWidth: '100%', maxHeight: '100%' }} /> : uploadButton}
      </Upload>
    </div>
    
  </div>
}